<template>
  <div>

    <el-row style="margin: 30px;" type="flex" justify="center" align="middle" :gutter="10">
      <el-col :span="4">
        <el-card class="home-num-card" @click.native="toBrowse('individual')">
          <div class="num">{{ individualNum }}</div>
          <!-- #624870 #b68cb8 #88527f #9f87af-->
          <div class="num-icon-div"><i class="iconfont icon-huanzhe" style="font-size: 50px;color: #88527f;"></i></div>
          <div class="title">Individual</div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="home-num-card" @click.native="toBrowse('study')">
          <div class="num">{{ studyNum }}</div>
          <!-- #eca72c -->
          <div class="num-icon-div"><i class="iconfont icon-yixueyingxiangke2" style="font-size: 50px;color: #eca72c;"></i></div>
          <div class="title">Study</div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="home-num-card" @click.native="toBrowse('image')">
          <div class="num">{{ imageNum }}</div>
          <!-- #548c2f #8ac926 #669d31-->
          <div class="num-icon-div"><i class="iconfont icon-yixueyingxiang2" style="font-size: 45px;color: #669d31;"></i></div>
          <div class="title">Image</div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="home-num-card" @click.native="toStatistics('modality')">
          <div class="num">{{ modalityNum }}</div>
          <!-- #d5c7bc #ffd300 #d1d646-->
          <div class="num-icon-div"><i class="iconfont icon-CTjiancha" style="font-size: 55px;color: #ffd300;"></i></div>
          <div class="title">Modality</div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="home-num-card" @click.native="toStatistics('anatomicalSite')">
          <div class="num">{{ anatomicalSiteNum }}</div>
          <div class="num-icon-div"><i class="iconfont icon-yixueyingxiang" style="font-size: 60px;color: #5eb1bf;"></i></div>
          <div class="title">Anatomical Site</div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="home-num-card" @click.native="toStatistics('disease')">
          <div class="num">{{ diseaseNum }}</div>
          <!-- #ab6d79 #c4a69d-->
          <div class="num-icon-div"><i class="iconfont icon-aixibao1" style="font-size: 48px;color: #ab6d79;"></i></div>
          <div class="title">Disease</div>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { getHomeNumber } from '@/api'

export default {
  name: 'CountNumCard',

  data () {
    return {
      diseaseNum: 0,
      collectionNum: 0,
      individualNum: 0,
      studyNum: 0,
      imageNum: 0,
      modalityNum: 0,
      anatomicalSiteNum: 0
    }
  },
  watch: {},
  computed: {},
  methods: {
    async getHomeNumber () {
      const data = await getHomeNumber()
      if (data.success) {
        var resp = data.data
        this.diseaseNum = resp.diseaseNum.toLocaleString()
        this.collectionNum = resp.collectionNum.toLocaleString()
        this.individualNum = resp.individualNum.toLocaleString()
        this.studyNum = resp.studyNum.toLocaleString()
        this.imageNum = resp.imageNum.toLocaleString()
        this.modalityNum = resp.modalityNum.toLocaleString()
        this.anatomicalSiteNum = resp.anatomicalSiteNum.toLocaleString()
      }
    },

    toBrowse (val) {
      if (val === 'image') {
        this.$router.push({
          path: '/browse',
          name: 'Browse',
          params: {
            view: 'image'
          }
        })
      } else if (val === 'study') {
        this.$router.push({
          path: '/browse',
          name: 'Browse',
          params: {
            view: 'study'
          }
        })
      } else {
        this.$router.push({
          path: '/browse',
          name: 'Browse'
        })
      }
    },

    toStatistics (val) {
      if (val === 'disease') {
        this.$router.push({
          path: '/statistics',
          name: 'Statistics',
          params: {
            tab: 'disease'
          }
        })
      } else if (val === 'anatomicalSite') {
        this.$router.push({
          path: '/statistics',
          name: 'Statistics',
          params: {
            tab: 'anatomicalSite'
          }
        })
      } else {
        this.$router.push({
          path: '/statistics',
          name: 'Statistics'
        })
      }
    }
  },
  created () {},
  mounted () {
    // 网页加载 请求统计数量
    this.getHomeNumber()
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/home/CountNumCard.vue